import "./ImageGalleryButton.css";

export const renderLeftNav = (onClick, disabled) => {
  return (
    <>
      <button
        type="button"
        className="image_gallery_custom_left_nav"
        disabled={disabled}
        onClick={onClick}
      >
        <i className="far fa-chevron-left left_arrow" />
      </button>
    </>
  );
};

export const renderRightNav = (onClick, disabled) => {
  return (
    <>
      <button
        type="button"
        className="image_gallery_custom_right_nav"
        disabled={disabled}
        onClick={onClick}
      >
        <i className="far fa-chevron-right right_arrow" />
      </button>
    </>
  );
};

export const renderFullscreenButton = (onClick, isFullscreen) => {
  return (
    <>
      <button
        type="button"
        className={`image_gallery_fullscreen ${isFullscreen ? " active" : ""}`}
        onClick={onClick}
      >
        <i className="right_arrow fa-lg far fa-expand" />
      </button>
    </>
  );
};
